import React from 'react';

export default class IEBrowserDetected extends React.Component {
    render = () => {
        return <div>go away!</div>
    }
}